import React, { useEffect, useState, useCallback } from "react";
import {
  Layout,
  Input,
  Button,
  Modal,
  Descriptions,
  Row,
  DatePicker,
  Form,
  InputNumber,
  Space,
  AutoComplete,
} from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import {
  doc,
  deleteDoc,
  updateDoc,
  serverTimestamp,
  collection,
  setDoc,
  getDocs,
} from "firebase/firestore";
import { db } from "../FirebaseApp";
import { useHistory } from "react-router-dom";
import FileManager from "./FileManager";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { selectDonates, getDonates } from "../redux/reducers/donate";
import { selectShops } from "../redux/reducers/shops";
import { getDownloadURL, getStorage, ref } from "firebase/storage";

const { Content } = Layout;
const { TextArea, Search } = Input;
const { RangePicker } = DatePicker;
const dateFormat = "YYYY-MM-DD";

let shopName = "";

const DonateInfo = (props) => {
  const dispatch = useDispatch();
  const formRef = React.createRef(null);
  const fileRef = React.createRef(null);
  const donates = useSelector(selectDonates);
  const shops = useSelector(selectShops);
  const history = useHistory();

  const [shopList, setShopList] = useState([]);
  const [shopID, setShopID] = useState("");

  const [name, setName] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [goal, setGoal] = useState(null);
  const [current, setCurrent] = useState(null);
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);
  const [description, setDescription] = useState("");
  const [files, setFiles] = useState(null);
  const id = props.match.params.id;

  const updateData = useCallback(() => {
    if (donates === null) return;
    const donate = donates[id];
    if (donate === undefined) {
      history.push({ pathname: "/donate" });
      return;
    }

    if (shops !== null) {
      shopName =
        shops[donate.data().shop_id] === undefined
          ? ""
          : shops[donate.data().shop_id].data().name;
      let tempShops = [];
      for (const shopsKey in shops) {
        tempShops.push({
          value: shops[shopsKey].data().name,
          label: shops[shopsKey].data().name,
          id: shops[shopsKey].data().id,
        });
      }
      setShopList(tempShops);
    }

    const docRef = doc(db, "donate", id);
    const filesRef = collection(docRef, "files");
    setFiles(filesRef);

    setName(donate.data().name);
    setSubtitle(donate.data().subtitle);
    setGoal(donate.data().goal);
    setCurrent(donate.data().current);
    setStart(donate.data().start.toDate());
    setEnd(donate.data().end.toDate());
    setDescription(donate.data().description);
    setShopID(donate.data().shop_id);
  }, [shops, history, id]);

  useEffect(() => {
    if (donates === null) {
      dispatch(getDonates());
      updateData();
    } else {
      updateData();
    }
  }, [donates, dispatch, updateData]);

  const onSelectShop = (value) => {
    shopName = value;
    setShopID(shopList.filter((shop) => shop.value === value)[0].id);
    console.log(shopID);
  };

  const modifyConfirm = (value) => {
    Modal.confirm({
      title: "기부 정보를 수정하시겠습니까?",
      icon: <ExclamationCircleOutlined />,
      content: "",
      okText: "수정",
      cancelText: "취소",
      async onOk() {
        const id = props.match.params.id;
        const docRef = doc(db, "donate", id);
        await updateDoc(docRef, {
          id: docRef.id,
          shop_id: shopID,
          name: value.name,
          subtitle: value.subtitle,
          // 'sponsor': value.sponsor,
          start: value.dateOfDonate[0]._d,
          end: value.dateOfDonate[1]._d,
          description: value.description,
          update: serverTimestamp(),
          goal: value.goal,
          current: value.current,
        });

        await deleteSubCollection(docRef, "files");
        const idList = await fileRef.current.addFiles();
        for (const idListKey in idList) {
          const data = idList[idListKey];
          const name = data.name;
          const uri = data.uri;
          const fileRef = doc(docRef, "files", data.id);
          await setDoc(fileRef, {
            id: data.id,
            create: serverTimestamp(),
            name,
            uri,
          });
          // const storage = getStorage();
          // getDownloadURL(ref(storage, data.name))
          //   .then(async (url) => {
          //     await setDoc(fileRef, {
          //       id: data.id,
          //       create: serverTimestamp(),
          //       link: url,
          //     });
          //   })
          //   .catch((error) => {
          //     // Handle any errors
          //   });
        }

        dispatch(getDonates());
        history.push({ pathname: "/donate" });
      },
    });
  };

  const deleteSubCollection = async (docRef, sub) => {
    const q = collection(docRef, sub);
    const docs = await getDocs(q);
    for (let i = 0; i < docs.size; i++) {
      const d = docs.docs[i];
      await deleteDoc(d.ref);
    }
    console.log(sub + " - collection all docs deleted");
  };

  const deleteConfirm = () => {
    Modal.confirm({
      title: "기부 정보를 삭제하시겠습니까?",
      icon: <ExclamationCircleOutlined style={{ color: "red" }} />,
      content: "",
      okText: "삭제",
      cancelText: "취소",
      async onOk() {
        const id = props.match.params.id;
        const docRef = doc(db, "donate", id);
        await deleteSubCollection(docRef, "files");
        await fileRef.current.deleteAll();
        await deleteDoc(docRef);
        dispatch(getDonates());
        history.push({ pathname: "/donate" });
      },
    });
  };

  return (
    <Content style={{ margin: "0 16px", height: "100%" }}>
      <div
        className="site-layout-background"
        style={{ padding: 24, height: "100%", marginTop: 0 }}
      >
        <div style={{ padding: 50, height: "100%" }}>
          <Form
            ref={formRef}
            layout="vertical"
            name="form_in_modal"
            fields={[
              {
                name: ["name"],
                value: name,
              },
              {
                name: ["subtitle"],
                value: subtitle,
              },
              {
                name: ["shopName"],
                value: shopName,
              },
              {
                name: ["goal"],
                value: goal,
              },
              {
                name: ["current"],
                value: current,
              },
              {
                name: ["dateOfDonate"],
                value: [moment(start, dateFormat), moment(end, dateFormat)],
              },
              {
                name: ["description"],
                value: description,
              },
            ]}
          >
            <Descriptions bordered>
              <Descriptions.Item label="기부 이름" span={3}>
                <Form.Item
                  name="name"
                  rules={[
                    { required: true, message: "기부 이름을 입력하세요." },
                  ]}
                >
                  <Input placeholder="기부 이름" style={{ width: "453px" }} />
                </Form.Item>
              </Descriptions.Item>
              <Descriptions.Item label="서브타이틀" span={3}>
                <Form.Item
                  name="subtitle"
                  rules={[
                    { required: true, message: "서브타이틀을 입력하세요." },
                  ]}
                >
                  <TextArea showCount maxLength={500} />
                </Form.Item>
              </Descriptions.Item>
              <Descriptions.Item label="후원처" span={3}>
                <Form.Item
                  name="shopName"
                  rules={[{ required: true, message: "후원처를 입력하세요." }]}
                >
                  <AutoComplete
                    style={{
                      width: 200,
                    }}
                    options={shopList}
                    placeholder=""
                    onSelect={onSelectShop}
                    filterOption={(inputValue, option) =>
                      option.value.indexOf(inputValue) !== -1
                    }
                    // defaultValue={shopName}
                  >
                    <Search placeholder="검색" />
                  </AutoComplete>
                  {/* <Search placeholder="input search text" style={{ width: 200 }} /> */}
                </Form.Item>
              </Descriptions.Item>
              <Descriptions.Item label="목표 코인" span={1}>
                <Form.Item
                  name="goal"
                  rules={[
                    { required: true, message: "목표 코인을 입력하세요." },
                  ]}
                >
                  <InputNumber />
                </Form.Item>
              </Descriptions.Item>
              <Descriptions.Item label="현재 코인" span={2}>
                <Form.Item
                  name="current"
                  rules={[
                    { required: true, message: "현재 코인을 입력하세요." },
                  ]}
                >
                  <InputNumber />
                </Form.Item>
              </Descriptions.Item>
              <Descriptions.Item label="모금 기간" span={3}>
                <Form.Item
                  name="dateOfDonate"
                  rules={[
                    { required: true, message: "모금 기간을 선택하세요." },
                  ]}
                >
                  <RangePicker />
                </Form.Item>
              </Descriptions.Item>
              <Descriptions.Item label="기부 설명" span={3}>
                <Form.Item
                  name="description"
                  rules={[{ required: true, message: "설명을 입력하세요" }]}
                >
                  <TextArea showCount />
                </Form.Item>
              </Descriptions.Item>
              <Descriptions.Item label="사진 추가하기" span={3}>
                <FileManager
                  ref={fileRef}
                  path={"donate"}
                  max={5}
                  files={files}
                />
              </Descriptions.Item>
            </Descriptions>
          </Form>

          <div
            style={{
              marginTop: "30px",
              display: "flex",
              alignItems: "flex-start",
            }}
          >
            <Button danger onClick={deleteConfirm}>기부 삭제</Button>
            <Row justify="end" style={{ width: "100%" }}>
              <Space>
                <Link to="/donate">
                  <Button>목록</Button>
                </Link>
                <Button
                  onClick={() => {
                    formRef.current
                      .validateFields()
                      .then((values) => {
                        modifyConfirm(values);
                      })
                      .catch((info) => {
                        console.log("Validate Failed:", info);
                      });
                  }}
                  type="primary"
                >
                  수정
                </Button>
              </Space>
            </Row>
          </div>
        </div>
      </div>
    </Content>
  );
};

export default DonateInfo;
